const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

// 2. Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav).
const targetElement = document.querySelector(".js-sub-category");

var $html = $('html');
var $header = $('.site-header');

var nav = $('.js-site-nav'),
  navContainer = $('.js-nav-container'),
  $toggleAction = $('.js-toggle-nav'),
  $closeAction = $('.js-close-nav'),
  $backAction = $('.js-back'),
  $catContainer = $('.js-cat-container'),
  subCategory = $('.js-sub-category'),
  $subMenuAction = $('.js-sub-menu-action');

function setupSearch() {
  $('.js-search-action').on('click', function(e) {
    var $search = $(this).closest('.site-nav__search')
    $html.toggleClass('js-search-opened')

    if ($html.hasClass('js-search-opened')) {
      setTimeout(function() {
        $search.find('input').focus()
      }, 600)
    }
    else {
      $search.find('input').val(null).blur()
    }
  })
}

function slideSearchInputs() {
  var searchParentContainer = $('.js-form-wrapper'),
      inputGroup = $('.js-input-group'),
      $slideAction = $('.js-input-drop-down'),
      searchContainer = $('.js-form-control-container');

  function closeOpenInput() {
    searchParentContainer.find('.is-active').removeClass('is-active');
  }

  $slideAction.on('click', function(){
    var $this = $(this);
    var activeInput = $this.closest(inputGroup).find(searchContainer);

    if(searchParentContainer.find('.is-active').length) {
      // there is an open dropdown input
      if(activeInput.hasClass('is-active')) {
        activeInput.removeClass('is-active');
      } else {
        closeOpenInput();
        activeInput.addClass('is-active');
      }
    } else {
      if(activeInput.hasClass('is-active')) {
        activeInput.removeClass('is-active');
      } else {
        activeInput.addClass('is-active');
      }
    }


  });
}

slideSearchInputs();
setupSearch();

function header() {
  var $siteHeader = $('.site-header'),
    headerHeight,
    distanceFromTop;

  function calculateHeaderHeight() {
    headerHeight = $siteHeader.outerHeight();
  }

  calculateHeaderHeight();

  function stickyHeader() {

    $(window).on('scroll', function(){

      distanceFromTop = $(window).scrollTop();
      // calculateHeaderHeight();

      if ($(window).scrollTop() > 1) {
          $('body').addClass('header-fixed');
          setBodyPadding();

      } else {
        $('body').removeClass('header-fixed');
        // calculateHeaderHeight();
        setBodyPadding();
      }
    });
  }

  stickyHeader();

  function setBodyPadding() {
    $('body').css('padding-top', ''+headerHeight+'px');
    // $('.header-bg-img-wrapper').css('margin-top', ''+headerHeight+'px');
  }

  setBodyPadding();

  $(window).on('resize', function(){
      calculateHeaderHeight();
      setBodyPadding();
  });
}

header();

function offCanvasNav() {

    var body = $('body'),
      nav = $('.js-site-nav'),
      navContainer = $('.js-nav-container'),
      $toggleAction = $('.js-toggle-nav'),
      $closeAction = $('.js-close-nav'),
      subCategory = $('.js-sub-category'),
      distanceFromTop;

    function checkDistanceFromTop() {
      distanceFromTop = $(window).scrollTop();
    }


    function toggleNav() {
      checkDistanceFromTop();
      if(body.hasClass('off-canvas-open')) {
        return;
      } else {
        body.addClass('off-canvas-open');
        disableBodyScroll(targetElement);
        nav.attr('aria-hidden', 'true');
        $('.js-site-nav').css('top', ''+distanceFromTop+'px');
        $('.site-header').css('top', ''+distanceFromTop+'px');
      }
    }

    function closeNav() {
      if(body.hasClass('off-canvas-open')) {
        body.removeClass('off-canvas-open');
        nav.attr('aria-hidden', 'false');
        showMainMenu();
        enableBodyScroll(targetElement);

        setTimeout(function () {
          $('.js-nav-container').css('top', '0px');
          $('.site-header').css('top', '0px');
        }, 300);

        if(subCategory.hasClass('is-active')) {
          setTimeout(function () {
            subCategory.removeClass('is-active');
            subCategory.attr('aria-expanded', 'false');
          }, 500);
        }
      }
    }

    function showSubMenu() {
      navContainer.css('transform', `translate3d(-100%, 0, 0)`);
    }

    function showMainMenu() {
      navContainer.css('transform', `translate3d(0%, 0, 0)`);
    }


    $toggleAction.on('click', function(e){
      e.preventDefault();
      toggleNav();
    });

    $closeAction.on('click', function(){
      closeNav();
    });

    $subMenuAction.on('click', function(e){
      e.preventDefault();
      showSubMenu();
      var subCat = $(this).closest($catContainer).find(subCategory);
      subCat.addClass('is-active');
      subCat.attr('aria-expanded', 'true');
    });

    $backAction.on('click', function(){
      var $this = $(this),
        subCat = $(this).closest($catContainer).find(subCategory);

      showMainMenu();
      setTimeout(function () {
        subCat.removeClass('is-active');
        subCat.attr('aria-expanded', 'false');
      }, 500);
    });


  }

  offCanvasNav();


var dropdown = document.querySelector('.js-cat-container');
dropdown.addEventListener('mouseover', function() {
    this.querySelector('.js-sub-category').classList.toggle('is-open');
    this.querySelector('.js-sub-nav-hover').classList.toggle('is-active');
});
dropdown.addEventListener('mouseout', function() {
    this.querySelector('.js-sub-category').classList.toggle('is-open');
    this.querySelector('.js-sub-nav-hover').classList.toggle('is-active');
});
